import { PinLog, useGetPinOptionsDropdownOptions } from "components";
import { pinsAttachments } from "components/PinModal/components/AddPinModalForm/utils/pinsAttachments";
import { createFormHelper } from "lib/Form";
import "modules/AppointmentDetails/components/Interventions/components/PinCategory/PinCategory.scss";
import { usePinCategory } from "modules/AppointmentDetails/components/Interventions/components/PinCategory/usePinCategory";
import { useAppointmentDealer } from "modules/AppointmentDetails/hooks";
import { PinCategoryForm } from "modules/HoldingAppointmentDetails/components/Interventions/components/PinCategory/components";

import type { DropdownItemProps } from "components";
import type { Appointment, Intervention, PIN_TYPES, Pin } from "models";
import type { PinCategoryFormType } from "modules/HoldingAppointmentDetails/components/Interventions/components/PinCategory/components";

type PinCategoryProps = {
  selectedPinTypeOption: DropdownItemProps<PIN_TYPES>;
  intervention: Intervention;
  latestPinData?: Pin;
  appointment: Appointment;
};

const FormHelper = createFormHelper<PinCategoryFormType>();

export const PinCategory = ({ intervention, appointment, latestPinData, selectedPinTypeOption }: PinCategoryProps) => {
  const appointmentDealer = useAppointmentDealer(appointment);
  const { pinOrderOptions, pinStatusOptions, pinTypeOptions, pinWarrantyOptions } = useGetPinOptionsDropdownOptions(appointmentDealer);

  const { attachments, setAttachments } = usePinCategory({ intervention, selectedPinTypeOption });

  const pinLogAttachments = pinsAttachments(intervention.pin_history);

  const defaultFormValues: PinCategoryFormType = {
    claimNr: latestPinData?.claim_nr || "",
    supportNr: latestPinData?.support_nr || "",
    refNr: latestPinData?.ref_nr || "",
    orderStatus: latestPinData?.order_status || null,
    pinWarrantyType: latestPinData?.warranty_type_id || null,
    pinStatus: latestPinData?.pin_status_id || null,
    keepParts: latestPinData?.keep_parts || false
  };

  return (
    <div className="PinType">
      <FormHelper.Form defaultValues={defaultFormValues}>
        <PinCategoryForm
          intervention={intervention}
          selectedPinTypeOption={selectedPinTypeOption}
          attachments={attachments}
          pinOrderOptions={pinOrderOptions}
          pinStatusOptions={pinStatusOptions}
          pinWarrantyOptions={pinWarrantyOptions}
          setAttachments={setAttachments}
        />
        <PinLog
          intervention={intervention}
          appointment={appointment}
          pinLog={intervention.pin_history}
          pinTypeOptions={pinTypeOptions}
          pinOrderOptions={pinOrderOptions}
          pinStatusOptions={pinStatusOptions}
          pinWarrantyOptions={pinWarrantyOptions}
          attachments={pinLogAttachments}
          readOnly
        />
      </FormHelper.Form>
    </div>
  );
};
